import React,{useState,useEffect, useMemo} from 'react'
import Dashboard from '../../components/dashboard/Dashboard'
import TaxComparison from '../../components/dashboard/TaxComparison'
import ReturnStatus from '../../components/dashboard/ReturnStatus'
import TaxableStatus from '../../components/dashboard/TaxableStatus'
import { motion } from 'framer-motion'
import UnderConstruction from '../../components/UnderConstruction'
import TdsTsxPage from './TdsTsxPage'
const Tds = () => {
    const [isSidebarOpen, setIsSidebarOpen] = useState(true)
  
    useEffect(()=>{
      const isSidebarOpen = localStorage.getItem('isSidebarOpen') === 'true'
      setIsSidebarOpen(isSidebarOpen)
    },[])

    // Prepare TDS comparison data
    const tdsComparisonData = useMemo(() => {
      const totalTDSClaimed = localStorage.getItem("total_tds_claimed") || 0
      
      const formatCurrency = (value) => {
        return new Intl.NumberFormat("en-IN", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }).format(Math.abs(value))
      }

      return {
        totalTDSClaimed: Number.parseFloat(totalTDSClaimed),
        oldRegimeTaxable: Number.parseFloat(totalTDSClaimed), // TDS can be claimed in both regimes
        newRegimeTaxable: Number.parseFloat(totalTDSClaimed), // TDS can be claimed in both regimes
        difference: 0, // No difference for TDS between regimes
        formatCurrency,
      }
    }, [])

  return (
    <Dashboard 
      salaryData={tdsComparisonData}
      showTaxComparison={false}
    >
      {/* <UnderConstruction/> */}
      <TdsTsxPage/>
    </Dashboard>
  )
}

export default Tds